export default "__VITE_ASSET__983ee2a2__";